import { useCallback, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import toast from "react-hot-toast";
import useDebounce from "../../hooks/useDebounce";
import { useCheckinRegistrations } from "../../hooks/useCheckinRegistration";
import { checkinV2Call } from "../../api/checkinV2";
import DeviceManagerTabsHeader from "./DeviceManagerTabsHeader";
import CheckinRegistrationTable from "./checkinRegistrationTable";

// Chấm công luồng mới - Bước 1: danh sách nhân viên đã đăng ký thiết bị + địa điểm
const headers = [
  { label: "Mã NV", key: "code", width: "8%" },
  { label: "Tên NV", key: "name", width: "14%" },
  { label: "Mã thiết bị", key: "deviceCode", width: "18%" },
  { label: "Loại thiết bị", key: "deviceName", width: "12%" },
  { label: "Phiên bản APP", key: "appVersion", width: "8%" },
  { label: "Địa điểm chấm công", key: "place", width: "18%" },
  { label: "Ngày đăng ký", key: "registeredAt", width: "10%" },
  { label: "Hành động", key: "action", width: "10%" },
];

const TableCheckinRegistration = () => {
  const [search, setSearch] = useState("");
  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => setSearch(e.target.value), []);

  const {
    items,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useCheckinRegistrations(debouncedSearchTerm);

  const deleteRegistration = async (row) => {
    const ok = window.confirm(
      `Xoá đăng ký chấm công của ${row.name} (${row.code})? Nhân viên sẽ phải đăng ký lại thiết bị và địa điểm trên app.`,
    );
    if (!ok) return;

    const toastId = toast.loading("Đang xoá đăng ký ...");
    try {
      await checkinV2Call.deleteRegistration(row.id);
      await refetch();
      toast.success("Đã xoá đăng ký, nhân viên cần đăng ký lại");
    } catch (error) {
      console.error("Error:", error);
    }
    toast.dismiss(toastId);
  };

  const renderCell = (key, row) => {
    if (key === "action") {
      return (
        <Button
          bg={"var(--color-main)"}
          color={"var(--color-option-employee-hover)"}
          border={"1px solid var(--color-option-employee-hover)"}
          fontSize={"12px"}
          fontWeight={"600"}
          h={"28px"}
          minH={"28px"}
          _hover={{ filter: "brightness(90%)" }}
          onClick={() => deleteRegistration(row)}
        >
          Xoá đăng ký
        </Button>
      );
    }
    return <Text>{row[key]}</Text>;
  };

  return (
    <>
      <DeviceManagerTabsHeader onRefreshCurrentTab={() => refetch()} />

      <Box mt={{ base: "23px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex p={"16px 16px 12px 16px"}>
            <InputGroup
              maxW="42vw"
              minW={"42vw"}
              borderRadius={{ base: "8px" }}
              w={{ base: "100%" }}
            >
              <Input
                placeholder="Tên NV, mã NV, mã thiết bị ..."
                type="text"
                borderRadius={{ base: "8px" }}
                border={{ base: "1px solid var(--color-boder)" }}
                backgroundColor={"var(--fill-avatar)"}
                onChange={(e) => {
                  onChangeSearch(e);
                  setCurrentPage(1);
                }}
              />
              <InputRightElement
                borderTopRightRadius={"8px"}
                borderBottomRightRadius={"8px"}
                pointerEvents="none"
                backgroundImage="var(--color-button)"
              >
                <SearchIcon color="var(--color-main)" />
              </InputRightElement>
            </InputGroup>
          </Flex>

          <CheckinRegistrationTable
            headers={headers}
            rows={items}
            renderCell={renderCell}
            isLoaded={!isLoading && !isRefetching}
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={(p) => setCurrentPage(p.selected + 1)}
            startEntry={startEntry}
            endEntry={endEntry}
            entries={entries}
          />
        </Flex>
      </Box>
    </>
  );
};

export default TableCheckinRegistration;
